module.exports = __webpack_public_path__ + "img/no_connect_person.86da43be.png";